import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  GET_RECHARGE_REWARDS,
  DELETE_RECHARGE_REWARD,
  ADD_RECHARGE_REWARD,
  CLOSE_RECHARGE_REWARD_DIALOG
} from "./types";

export const getRechargeRewards = () => (dispatch) => {
  axios
    .get(`rechargeReward`)
    .then((res) => {
      console.log("rechargeReward", res.data);
      if (res.data.status) {
        dispatch({ type: GET_RECHARGE_REWARDS, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const deleteRechargeReward = (data) => (dispatch) => {
  console.log("deleteRechargeReward data", data);
  axios
    .delete(`rechargeReward/reward`, { data })
    .then((res) => {
      console.log("deleteRechargeReward", res.data);
      if (res.data.status) {
        dispatch({
          type: DELETE_RECHARGE_REWARD,
          payload: res.data.data,
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const addRechargeReward = (data) => (dispatch) => {
  console.log("addRechargeReward data", data);
  axios
    .post(`rechargeReward/reward`, data)
    .then((res) => {
      console.log("addRechargeReward", res.data);
      if (res.data.status) {
        dispatch({
          type: ADD_RECHARGE_REWARD,
          payload: res.data.data,
        });
        dispatch({
          type: CLOSE_RECHARGE_REWARD_DIALOG
        });
      } else {
        Toast("error", res.data.message);
        console.log("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
